export default __webpack_public_path__ + "static/media/al.dd17f9b0.svg";